// extracted by mini-css-extract-plugin
export default {"box":"Projects_box__jsPYj","display":"Projects_display__QXUVz","btn":"Projects_btn__C183C"};